import { Component, OnInit, Input } from '@angular/core';
import { Note } from '../note'
import { NoteService } from '../note.service'
import { UtilsService } from '../utils.service'
import { UsersService } from '../users.service'
import { RuntimeService } from '../runtime.service'
import { DbRecord } from '../db-record'


@Component({
  selector: 'app-note-box',
  templateUrl: './note-box.component.html',
  styleUrls: ['./note-box.component.css']
})
export class NoteBoxComponent implements OnInit {
  @Input() note: Note
  @Input() dbRecord: DbRecord

  isEditMode = false
  isRemoveMode = false
  editText: string

  constructor(
    private utils: UtilsService,
    private users: UsersService,
    private ns: NoteService,
    private rs: RuntimeService
  ) {

  }

  ngOnInit() {
    if (this.note && this.note.isNew)
      this.isEditMode = true
  }

  get isDbRecordNote() {
    return !!this.dbRecord
  }

  get text() {
    if (!this.note)
      return ''
    return this.note.text.replace(/\n/g, '<br>')
  }

  get date() {
    if (!this.note || !this.note.date)
      return ""
    return this.note.date.toUTCString()
  }

  get isOwner() {
    return this.note.creator == this.utils.email
  }

  switchEditMode() {
    this.isEditMode = !this.isEditMode
    if (this.isEditMode)
      this.editText = this.note.text
    if (!this.isEditMode && this.note.isNew)
      this.note = null
  }

  switchRemoveMode() {
    this.isRemoveMode = !this.isRemoveMode
  }


  createNote() {
    this.note = this.ns.newNote(this.dbRecord)
  }

  save() {
    if (this.editText.trim() == '') {
      let obs = this.ns.delete(this.note)
      obs.subscribe((x) => {
        if (x['isSuccess'])
          this.note = null
        this.isEditMode = false
      })
      return
    }

    this.note.text = this.editText
    let obs = this.ns.save(this.note)
    obs.subscribe((x) => {
      this.isEditMode = false
    })
  }


}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/note-box/note-box.component.ts